import HttpClient from '@/services/http-client'

class AnomalyResultService extends HttpClient {
  async show(id) {
    return this.rest.get('/v1/anomaly-results/' + id)
  }

  async list(page = 1, limit = 1000, text = null) {
    return this.rest.get('/v1/anomaly-results', {
      params: {
        page,
        limit,
        q: text
      }
    })
  }

  async create(payload) {
    return this.rest.post('/v1/anomaly-results', payload)
  }

  async update(payload) {
    return this.rest.patch('/v1/anomaly-results/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/anomaly-results/' + id)
  }
}

export default () => new AnomalyResultService()
